export const lastUpdateDate = "28.07";
